import api from '../../../../api';
import {
  CreateCanvasAssetRequest,
  CreateCanvasAssetResponse,
} from '@dreamai/types';

interface CreateConfirmationCanvasAssetParams {
  confirmationIds: string[];
  threadId: string;
  getAccessTokenSilently: () => Promise<string>;
  title?: string;
}

export const createConfirmationCanvasAsset = async ({
  confirmationIds,
  threadId,
  getAccessTokenSilently,
  title = 'Action Needs Confirmation',
}: CreateConfirmationCanvasAssetParams): Promise<void> => {
  try {
    const token = await getAccessTokenSilently();
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    const createRequest: CreateCanvasAssetRequest = {
      threadId: threadId,
      title: title,
      components: [
        {
          type: 'ConfirmationCarousel',
          props: {
            confirmationIds: confirmationIds,
          },
          order: 1,
        },
      ],
    };

    const response = await api.post('/canvas-assets', createRequest);
    const data: CreateCanvasAssetResponse = response.data;

    if (data.success) {
      console.log(
        'Canvas asset created successfully:',
        data.asset?.canvasAssetId,
      );
      // The canvas system will automatically switch to the new asset via pusher events
    } else {
      console.error('Failed to create canvas asset:', data.error);
    }
  } catch (err) {
    console.error('Error creating canvas asset for confirmation:', err);
  }
};
